import { call, put } from "redux-saga/effects";
import { routes } from "../../common/api/routes";
import { applyPostSignInRedirect } from "../../common/signInRedirect";
import { clearAuthRevoked } from "../../common/authSession";
import {
  getUSERFromLocalStorage,
  setUSERInLocalStorage,
} from "../../common/localStorage";
import {
  onBoardingGet,
  onBoardingGetError,
  onBoardingGetSuccess,
  onBoardingUpdate,
  onBoardingUpdateError,
  onBoardingUpdateSuccess,
  signIn,
  signInError,
  signInSuccess,
} from "../actions";
import { initFetchPromptStatus } from "../actions/promptActions";

export function* signInSaga({ payload }) {
  yield put(signIn());
  try {
    const response = yield call(routes.auth, payload);
    clearAuthRevoked();
    yield put(signInSuccess(response));
    // Run before React effects so nothing else can `navigate("/profile")` first.
    applyPostSignInRedirect({ loginResponse: response });
    if (response?.user?.role === "Student") {
      yield put(initFetchPromptStatus());
    }
  } catch (error) {
    yield put(signInError(error));
  }
}

export function* onboardingGetSaga() {
  yield put(onBoardingGet());
  try {
    const response = yield call(routes.getOnboarding);
    yield put(onBoardingGetSuccess(response));
  } catch (error) {
    yield put(onBoardingGetError(error));
  }
}

export function* onboardingUpdateSaga({ payload }) {
  yield put(onBoardingUpdate());
  try {
    const response = yield call(routes.updateOnboarding, payload);
    yield put(onBoardingUpdateSuccess(response));
    if (response && typeof response.onboarding_complete === "boolean") {
      const user = getUSERFromLocalStorage();
      if (user) {
        setUSERInLocalStorage({
          ...user,
          onboarding_complete: response.onboarding_complete,
        });
      }
    }
  } catch (error) {
    yield put(onBoardingUpdateError(error));
  }
}
